import { METHODS, TUTORIAL_STEPS } from "./data.js";

const defaultMethod = METHODS[0]!.id;
const stepPath =
  /^\/(?:docs\/)?getting-started\/([^/]+)\/([^/]+)(?:\/([^/]+))?\/?$/;

const hasStep = (build: string, method: string, slug: string) =>
  TUTORIAL_STEPS[`${build}:${method}`]?.some((step) => step.slug === slug) ??
  false;

const parseStep = (pathname: string) => {
  const match = stepPath.exec(pathname);
  if (!match) return null;

  const [, build, slug, suffix] = match;
  const method = suffix ?? defaultMethod;
  if (!hasStep(build!, method, slug!)) return null;

  return { build: build!, slug: slug!, method };
};

/** Resolve a sidebar step link from the current tutorial URL alone. */
export const tutorialSidebarHref = (pathname: string, href: string) => {
  if (!href.startsWith("/")) return null;

  const url = new URL(href, "https://docs.zuplo.com");
  if (url.origin !== "https://docs.zuplo.com") return null;
  const step = parseStep(url.pathname);
  if (!step) return null;

  const current = parseStep(pathname);
  const method =
    current?.build === step.build &&
    hasStep(step.build, current.method, step.slug)
      ? current.method
      : defaultMethod;
  const base = url.pathname
    .replace(/\/$/, "")
    .replace(/\/(local|agent|portal)$/, "");
  const path = method === defaultMethod ? base : `${base}/${method}`;
  return `${path}${url.search}${url.hash}`;
};

/** Strip React Router's basename before passing a real href to navigate(). */
export const tutorialSidebarRoute = (href: string, routerRoot: string) => {
  const base = routerRoot.replace(/\/$/, "");
  const url = new URL(href, "https://docs.zuplo.com");
  if (base && url.pathname !== base && !url.pathname.startsWith(`${base}/`)) {
    return null;
  }
  const pathname = url.pathname.slice(base.length) || "/";
  return `${pathname}${url.search}${url.hash}`;
};
